interface ChevronDownProps {
  /** Tailwind class string. Defaults to a sensible 16x16 size. */
  readonly className?: string;
  /** Decorative by default — pass false ONLY if the icon is the
   *  sole label for an interactive element (rare). */
  readonly 'aria-hidden'?: boolean | 'true' | 'false';
}

/**
 * Single source of truth for the chevron-down glyph used across
 * the app: dropdowns, accordions, "expand" toggles. Stroke icon
 * (Lucide-style) so it matches the rest of the line-icon family
 * (search magnifier, close X).
 *
 * Default size is `h-4 w-4` (~16px); pass a different `className`
 * to override. Caller is responsible for rotation (`rotate-180`)
 * and color (`text-text-4`, `text-navy`, etc.) — keeps this
 * component free of state knowledge so it composes cleanly.
 *
 * @example
 *   <ChevronDown className={cn('h-3.5 w-3.5 text-text-4', isOpen && 'rotate-180 text-navy')} />
 */
export function ChevronDown({ className = 'h-4 w-4', ...rest }: ChevronDownProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
